<div class="row">
  <div class="col-xxl-3 col-xl-6 col-lg-4 col-md-6 col-sm-12">
    <mat-form-field>
      <mat-label>Barcode</mat-label>
      <input cdkFocusInitial matInput #barcodeInput [formControl]="form.controls.barcode" placeholder="Enter Barcode" />
    </mat-form-field>
  </div>

  <div class="col-xxl-9 col-xl-12 col-lg-8 col-sm-12">
    <mat-form-field class="field-with-icon-suffix">
      <mat-label>Product</mat-label>

      <input matInput [formControl]="form.controls.product" [matAutocomplete]="auto" placeholder="Search Product" />

      <mat-autocomplete #auto="matAutocomplete">
        <mat-option
          *ngFor="let option of hideNotInStock ? form.inStockProductOptions : form.options.products"
          [value]="option.name">
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>

      <mat-spinner *ngIf="isLoading" matSuffix diameter="20" />

      <button
        matSuffix
        mat-icon-button
        *ngIf="!isLoading && productSelected"
        (pointerdown)="openProductPage($event)"
        matTooltip="Open Product Page">
        <mat-icon>open_in_new</mat-icon>
      </button>

      <button
        *ngIf="!isLoading"
        matSuffix
        mat-icon-button
        (click)="refreshProductOptions()"
        matTooltip="Refresh Product Options">
        <mat-icon>refresh</mat-icon>
      </button>

      <button *ngIf="!isLoading" matSuffix mat-icon-button (click)="clearProduct()" matTooltip="Clear Product">
        <mat-icon>close</mat-icon>
      </button>

      <mat-hint>{{ currentStock }}</mat-hint>
    </mat-form-field>
  </div>
</div>
